import { onMounted, onUnmounted, type Ref } from 'vue'

interface UseGesturesOptions {
  onDoubleTap?: () => void
  onShake?: () => void
  isEnabled?: Ref<boolean> | boolean
}

export function useGestures({ onDoubleTap, onShake, isEnabled }: UseGesturesOptions) {
  let lastTap = 0
  let lastShake = 0

  const handleTouchEnd = (e: TouchEvent) => {
    const enabled = typeof isEnabled === 'boolean' ? isEnabled : isEnabled?.value
    if (!enabled) return

    const now = Date.now()
    if (now - lastTap < 300) {
      onDoubleTap?.()
    }
    lastTap = now
  }

  const handleDoubleClick = (e: MouseEvent) => {
    const enabled = typeof isEnabled === 'boolean' ? isEnabled : isEnabled?.value
    if (!enabled) return
    onDoubleTap?.()
  }

  const handleKeyDown = (e: KeyboardEvent) => {
    const enabled = typeof isEnabled === 'boolean' ? isEnabled : isEnabled?.value
    if (!enabled) return
    // Barra espaciadora o tecla S para saltar (shake)
    if (e.code === 'Space' || e.code === 'KeyS') {
      e.preventDefault()
      onShake?.()
    }
  }

  const handleDeviceMotion = (e: DeviceMotionEvent): void => {
    const enabled = typeof isEnabled === 'boolean' ? isEnabled : isEnabled?.value
    if (!enabled) return

    const acc = e.accelerationIncludingGravity
    if (acc) {
      const total = Math.abs(acc.x || 0) + Math.abs(acc.y || 0) + Math.abs(acc.z || 0)
      if (total > 30) {
        const now = Date.now()
        if (now - lastShake > 1000) {
          onShake?.()
          lastShake = now
        }
      }
    }
  }

  onMounted(() => {
    // Móvil: touchend para doble tap
    window.addEventListener('touchend', handleTouchEnd)
    // Desktop: dblclick para doble tap
    window.addEventListener('dblclick', handleDoubleClick)
    // Desktop: teclado para shake (espacio o S)
    window.addEventListener('keydown', handleKeyDown)
    // Móvil: devicemotion para shake
    window.addEventListener('devicemotion', handleDeviceMotion)
  })

  onUnmounted(() => {
    window.removeEventListener('touchend', handleTouchEnd)
    window.removeEventListener('dblclick', handleDoubleClick)
    window.removeEventListener('keydown', handleKeyDown)
    window.removeEventListener('devicemotion', handleDeviceMotion)
  })

  return {
    handleTouchEnd,
    handleDoubleClick,
    handleKeyDown,
    handleDeviceMotion
  }
}
